import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root')

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

function ShareCard(props) {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function copyToClipboard() {
    // TODO
    navigator.clipboard.writeText(props.url)
  }

  return (
    <div>
      <div onClick={openModal} className="rounded shadow-md text-white bg-purple-600 hover:bg-purple-500 px-2 py-1 duration-100">
        Share Your Savings
      </div>

      <Modal
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal" >
        <div className="w-96 flex flex-col">
          <h2 className="font-raleway pb-4 font-semibold">Here is your sharing link:</h2>

          <div className="flex">
            <div className="border border-gray-300 shadow-sm rounded-md w-full px-2 py-0.5 flex">
              <div className="flex-1 whitespace-nowrap overflow-scroll mr-4">{props.url || 'Link'}</div>
              <svg onClick={copyToClipboard} className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"></path>
              </svg>
            </div>
          </div>

          <div className="flex justify-end">
            <button className="bg-red-500 rounded shadow-lg text-white px-2 py-1 justify-end mt-6" onClick={closeModal}>Close</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default ShareCard;



